import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';
import { BannerCarouselFull } from '../components/BannerCarousel';

const ASSET = '/assets/';

const PARCEIROS = [
  {
    id: 1,
    nome: 'Consórcio Heritage',
    categoria: 'Consórcio',
    descricao: 'Realize o sonho do seu clássico com planos de consórcio exclusivos para veículos antigos.',
    whatsapp: '5531900000001',
    instagram: 'consorcioheritagebh',
    cor: '#9a5637',
  },
  {
    id: 2,
    nome: 'Seguro Clássicos',
    categoria: 'Seguro',
    descricao: 'Proteção especializada para veículos antigos e de coleção. Coberturas pensadas para quem entende.',
    whatsapp: '5531900000002',
    instagram: 'seguroclaasicobr',
    cor: '#102133',
  },
  {
    id: 3,
    nome: 'Selante Heritage',
    categoria: 'Produto',
    descricao: 'Linha de cuidados automotivos desenvolvida para preservar a pintura e o acabamento dos clássicos.',
    whatsapp: '5531900000003',
    instagram: 'selanteheritagebr',
    cor: '#34403d',
  },
];

const fallbackCampaigns = [
  { id: 1, tipo: 'produto',    titulo: 'Selante Heritage',    texto: 'Cuidados, brilho e proteção para o seu clássico.' },
  { id: 2, tipo: 'consorcio',  titulo: 'Consórcio Heritage',  texto: 'Planos para realizar o sonho do seu clássico.' },
  { id: 3, tipo: 'seguro',     titulo: 'Seguro para Clássicos', texto: 'Proteção especializada para veículos antigos.' },
];

const labelByType = {
  consorcio:     'Consórcio',
  seguro:        'Seguro',
  selante:       'Produto',
  produto:       'Produto',
  institucional: 'Heritage',
};

function fmtPreco(v) {
  return v ? `R$ ${Number(v).toLocaleString('pt-BR')}` : 'A consultar';
}

function DestaqueCard({ v }) {
  const badge = v.placa_preta ? 'Placa preta' : v.original ? 'Original' : v.restaurado ? 'Restaurado' : null;
  return (
    <div className="destaque-card">
      <div className="destaque-card-foto">
        {v.foto_principal
          ? <img src={v.foto_principal} alt={`${v.marca} ${v.modelo}`} />
          : <div className="destaque-card-foto-placeholder">&#128663;</div>
        }
        {badge && <span className="destaque-card-badge">{badge}</span>}
      </div>
      <div className="destaque-card-info">
        <div className="destaque-card-titulo">{v.marca} {v.modelo}</div>
        <div className="destaque-card-meta">{v.ano}{v.cidade ? ` · ${v.cidade}` : ''}</div>
        <div className="destaque-card-preco">{fmtPreco(v.preco)}</div>
        <Link to="/planos" className="destaque-card-cta">Ver detalhes →</Link>
      </div>
    </div>
  );
}

export default function LandingPage() {
  const [campanhas,  setCampanhas]  = useState([]);
  const [destaques,  setDestaques]  = useState([]);

  useEffect(() => {
    api.get('/campanhas?local=ticker')
      .then(({ data }) => setCampanhas(data))
      .catch(() => setCampanhas([]));

    api.get('/veiculos/destaques')
      .then(({ data }) => setDestaques(data))
      .catch(() => setDestaques([]));
  }, []);

  const campaignItems = (campanhas.length ? [...campanhas.slice(0, 3), ...fallbackCampaigns] : fallbackCampaigns).slice(0, 3);

  return (
    <main className="reference-home">
      <section className="top-ad-strip" aria-label="Campanhas Heritage">
        <div className="top-ad-track">
          {campaignItems.map(item => (
            <Link to="/planos" className={`top-ad top-ad-${item.tipo || 'institucional'}`} key={item.id}>
              <span>{labelByType[item.tipo] || 'Heritage'}</span>
              <strong>{item.titulo}</strong>
              <em>{item.texto}</em>
            </Link>
          ))}
        </div>
      </section>

      <Navbar />

      <section className="market-hero">
        <div className="container market-hero-inner">
          <div className="hero-copy">
            <p className="eyebrow">Plataforma nacional de assinatura para clássicos</p>
            <h1>A plataforma para quem compra, vende e vive o universo dos carros antigos.</h1>
            <p className="hero-lead">
              Acesse anúncios exclusivos de veículos antigos, produtos automotivos da Heritage e, no plano
              Premium, anuncie seu próprio carro com análise prévia da nossa equipe.
            </p>
            <div className="hero-actions">
              <Link to="/planos" className="primary-button">Ver planos</Link>
              <Link to="/cadastro" className="ghost-button">Criar minha conta</Link>
            </div>
          </div>

          <div className="hero-access-card">
            <span>Acesso por assinatura</span>
            <h2>O catálogo completo é exclusivo para assinantes ativos.</h2>
            <p>
              Com a assinatura ativa, você acessa os anúncios, fotos, detalhes dos veículos e dados de contato
              dos vendedores. No plano Premium, pode enviar seu veículo para análise e publicação.
            </p>
            <ul>
              <li>Plano Básico para comprar e acompanhar oportunidades.</li>
              <li>Plano Premium para comprar e anunciar com curadoria.</li>
              <li>Negociação direta entre comprador e vendedor.</li>
            </ul>
            <Link to="/planos" className="search-button">Ver planos de acesso</Link>
          </div>
        </div>
      </section>

      <section className="responsibility-banner">
        <div className="container">
          <p>
            A Web Heritage funciona como plataforma de assinatura. A venda dos veículos acontece diretamente entre
            anunciante e comprador, sem intermediação financeira da Web Heritage.
          </p>
        </div>
      </section>

      {destaques.length > 0 && (
        <section className="destaques-section">
          <div className="container">
            <div className="destaques-heading">
              <h2>Destaques da semana</h2>
              <Link to="/planos">Assine para ver o catálogo completo →</Link>
            </div>
            <div className="destaques-grid">
              {destaques.map(v => <DestaqueCard key={v.id} v={v} />)}
            </div>
          </div>
        </section>
      )}

      <section className="dark-steps" id="como-funciona">
        <div className="container">
          <article>
            <span>01</span>
            <h3>Assine e acesse</h3>
            <p>Escolha o plano ideal e tenha acesso imediato aos anúncios, produtos e recursos da plataforma.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Análise prévia</h3>
            <p>Todo veículo enviado por assinantes Premium é revisado pela nossa equipe antes de ser publicado no catálogo.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Negociação direta</h3>
            <p>Compradores e vendedores negociam diretamente via WhatsApp, sem intermediação financeira da Heritage.</p>
          </article>
        </div>
      </section>

      <section className="plans-preview">
        <div className="container">
          <div className="plans-heading">
            <div>
              <p className="eyebrow">Planos de assinatura</p>
              <h2>Escolha o plano ideal para o seu perfil.</h2>
            </div>
            <p>
              Dois planos simples: um para comprar e acompanhar oportunidades, outro para também anunciar
              seu veículo clássico com curadoria da Heritage.
            </p>
          </div>

          <div className="plan-grid refined">
            <article className="plan-card refined-card">
              <div className="plan-card-top">
                <span>Básico</span>
                <small>Compra e acompanhamento</small>
              </div>
              <strong>R$ 9,90<small>/mês</small></strong>
              <p>Acesso ao catálogo de compra, detalhes dos veículos publicados, produtos Heritage e contato direto com anunciantes.</p>
              <ul>
                <li>Catálogo de veículos liberado</li>
                <li>Fotos e informações completas</li>
                <li>Contato direto com vendedores</li>
                <li>Produtos e campanhas Heritage</li>
              </ul>
              <Link to="/cadastro">Começar no Básico — 7 dias grátis</Link>
            </article>

            <article className="plan-card refined-card featured">
              <div className="recommended-badge">Mais completo</div>
              <div className="plan-card-top">
                <span>Premium</span>
                <small>Compra, venda e curadoria</small>
              </div>
              <strong>R$ 19,90<small>/mês</small></strong>
              <p>Tudo do Básico, mais acesso à área de venda para anunciar seu veículo. Até 5 anúncios inclusos; extras por R$ 5,00/un.</p>
              <ul>
                <li>Tudo incluído no plano Básico</li>
                <li>Até 5 anúncios inclusos no plano</li>
                <li>Upload de fotos do veículo</li>
                <li>Publicação após aprovação Heritage</li>
                <li>Anúncios adicionais por R$ 5,00/un.</li>
              </ul>
              <Link to="/cadastro">Assinar Premium — 7 dias grátis</Link>
            </article>
          </div>

          <div className="plan-note">
            <strong>Negociação direta:</strong> a Web Heritage divulga os anúncios para assinantes, mas não
            intermedeia pagamentos, transferência, vistoria ou entrega dos veículos.
          </div>
        </div>
      </section>

      <section aria-label="Produtos e serviços Heritage">
        <BannerCarouselFull />
      </section>

      <section className="parceiros-section" id="parceiros">
        <div className="container">
          <div className="parceiros-heading">
            <div>
              <p className="eyebrow">Parceiros Web Heritage</p>
              <h2>Serviços especializados para o universo dos clássicos.</h2>
            </div>
            <p>Parceiros selecionados para oferecer soluções em consórcio, seguro, produtos e serviços voltados ao público de veículos antigos.</p>
          </div>
          <div className="parceiros-grid">
            {PARCEIROS.map(p => (
              <div key={p.id} className="parceiro-card">
                <div className="parceiro-badge" style={{ background: p.cor }}>{p.categoria}</div>
                <h3 className="parceiro-nome">{p.nome}</h3>
                <p className="parceiro-desc">{p.descricao}</p>
                <div className="parceiro-links">
                  {p.whatsapp && (
                    <a href={`https://wa.me/${p.whatsapp}`} target="_blank" rel="noopener noreferrer" className="parceiro-link parceiro-link-wa">
                      WhatsApp
                    </a>
                  )}
                  {p.instagram && (
                    <a href={`https://instagram.com/${p.instagram}`} target="_blank" rel="noopener noreferrer" className="parceiro-link parceiro-link-ig">
                      Instagram
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          <p className="parceiros-nota">Quer ser parceiro da Web Heritage? <a href="https://wa.me/5531972541567" target="_blank" rel="noopener noreferrer">Entre em contato pelo WhatsApp.</a></p>
        </div>
      </section>

      <section className="about-heritage">
        <div className="container about-grid">

          {/* Foto — coluna esquerda */}
          <div className="about-photo-wrap">
            <img src={`${ASSET}Eventos-1.png`} alt="Evento da comunidade Heritage" />
            <div className="about-photo-badge">
              <span>&#10022;</span>
              Comunidade Heritage
            </div>
          </div>

          {/* Texto — coluna direita */}
          <div className="about-copy">
            <div className="about-eyebrow">
              <span className="about-eyebrow-rule" />
              <span>Sobre a Web Heritage</span>
            </div>

            <h2 className="about-heading">
              Uma plataforma feita para quem vive o universo dos clássicos.
            </h2>

            <div className="about-values">
              <div className="about-value">
                <div className="about-value-num">01</div>
                <div>
                  <strong>Curadoria especializada</strong>
                  <p>Todo anúncio é revisado pela equipe antes de entrar no catálogo.</p>
                </div>
              </div>
              <div className="about-value">
                <div className="about-value-num">02</div>
                <div>
                  <strong>Alcance nacional</strong>
                  <p>Compradores e vendedores de todo o Brasil, sem fronteiras regionais.</p>
                </div>
              </div>
              <div className="about-value">
                <div className="about-value-num">03</div>
                <div>
                  <strong>Negociação direta</strong>
                  <p>Conectamos comprador e vendedor — sem intermediação financeira.</p>
                </div>
              </div>
            </div>

            <Link to="/termos" className="about-cta outline-button">Ver termos de uso</Link>
          </div>

        </div>
      </section>
    </main>
  );
}
